import { Injectable } from '@angular/core';
import vJson from '../../assets/versionStamp.json';

@Injectable({
    providedIn: 'root',
})
export class AppReleaseService {
    public readonly version = vJson.Version;
    private readonly releaseDate = vJson.ReleaseDate;
    private readonly commitId = vJson.GitCommitId;

    public logAppReleaseInfo(): void {
        console.info('App Version: ' + this.version);
        console.info('App Release Date: ' + this.releaseDate);
        console.info('App Commit Id: ' + this.commitId);
    }
}
